/* eslint-disable */
export default {
  to: '수신자',
  enterNameOrNumber: '이름 또는 번호 입력',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
